module.exports = __webpack_public_path__ + "img/yonghu.2299d6e9.png";